export default __webpack_public_path__ + "static/company-at-work-mobile-0b63fee3b742f46cef0ad23d635408f2.png";